// Duplicate carousel logos

import { duplicateCarouselLogos } from './modules/duplicate-carousel-logos';

duplicateCarouselLogos();

// GSAP

import { changeColorScroll } from './gsap-animations';

changeColorScroll();

// Scrolling marquee

import { marquee } from './gsap-animations';

marquee();

// Text marquee

import { textMarquee } from './gsap-animations';

textMarquee();

// Swiper

import { testimonialSwiper } from './swiper';

testimonialSwiper();

import { multipleTestimonialsSwiper } from './swiper';

multipleTestimonialsSwiper();

import { newsSwiper } from './swiper';

newsSwiper();

import { articleSwiper } from './swiper';

articleSwiper();

import { featuredSwiper } from './swiper';

featuredSwiper();

import { gallerySwiper } from './swiper';

gallerySwiper();

import { subpageSwiper } from './swiper';

subpageSwiper();

import { featuresSwiper } from './swiper';

featuresSwiper();

import { categorySwiper } from './swiper';

categorySwiper();

import { featuredSupplierSwiper } from './swiper';

featuredSupplierSwiper();

import { relatedSupplierSwiper } from './swiper';

relatedSupplierSwiper();

// Lightgallery

import { lightGallerySingle } from './lightgallery';

lightGallerySingle();

import { lightGalleryVideo } from './lightgallery';

lightGalleryVideo();

import { lightGalleryMutiple } from './lightgallery';

lightGalleryMutiple();

// Lazy load

import LazyLoad from 'vanilla-lazyload';

window.lazyLoadInstance = new LazyLoad({
    elements_selector: '.lazy',
});

// Back to top button

import { backtotop } from './modules/back-to-top';

backtotop();

// FAQ accordion

import { accordion } from './modules/accordion';

accordion();

import { scrollAnchor } from './modules/scroll-to-anchor';

scrollAnchor();

// Search overlay toggle

import { searchOverlay } from './modules/search-overlay';

searchOverlay();

// Mobile menu toggle

import { mobileMenu } from './modules/mobile-menu';

if (!document.querySelector('.promoter-socials-page')) {
    mobileMenu('.c-burger', '#fullscreen-menu');
}

import { psMobileMenu } from './modules/promoter-socials-mobile-menu';

psMobileMenu();

// Progress bar

import { progressBar } from './modules/progress-bar';

progressBar();

// Slide toggle

import { slideToggle } from './modules/slide-toggle';

slideToggle();

// News article category filter

import { newsFilter } from './modules/news-filter';

newsFilter();

// Tabs

import { tabs } from './modules/tabs';

tabs();

// Hide CTA banner on scroll

import { hideCtaBanner } from './modules/hide-cta-banner';

hideCtaBanner();

// Landing page header CTAs: hide fixed mobile dock when scrolled to footer
import { landingCtaDockHideAtBottom } from './modules/landing-cta-dock-hide-at-bottom';

landingCtaDockHideAtBottom();

// Process steps hover state

import { processStepsHover } from './modules/process-steps';

processStepsHover();

//  Listing steps hover state

import { listingStepsHover } from './modules/listing-steps';

listingStepsHover();

//  Load more blog posts

import { loadMorePosts } from './modules/load-more-posts';

loadMorePosts();

//  Load more category posts

import { loadMoreCatPosts } from './modules/load-more-category-posts';

loadMoreCatPosts();

//  Load more tag posts

import { loadMoreTagPosts } from './modules/load-more-tag-posts';

loadMoreTagPosts();

//  Load more author posts

import { loadMoreAuthorPosts } from './modules/load-more-author-posts';

loadMoreAuthorPosts();

//  Blog article hover

import { blogArticleHover } from './modules/blog-article-hover';

blogArticleHover();

// Clear search input

import { clearInput } from './modules/clear-input';

clearInput();

// Top level sub menu reveal

import { subMenus } from './modules/sub-menus';

subMenus();

// Footer menu accordion

import { footerAccordion } from './modules/footer-accordions';

footerAccordion();

// Cookie statement

import { cookie } from './modules/cookie';

cookie();

// Newsletter subscribe

import { newsletter } from './modules/newsletter-subscribe';

newsletter();

// Swiper carousel inactive slide hover

import { swiperHover } from './modules/swiper-sibling-hover';

swiperHover();

// Fit text to page width

import { fitTextPage } from './modules/fit-text';

fitTextPage();

// Close download pop up

import { downloadModal } from './modules/download-modal';

downloadModal();

// Blog modal

import { modalPopup } from './modules/modal-popup';

modalPopup();

// PDF downloads

import { resourceDownloads } from './modules/resource-downloads';

resourceDownloads();

// Hero image carousel

import { homeHeroCarousel } from './modules/home-hero-carousel';

homeHeroCarousel();

// Pipedrive bot trigger open

import { pipedrive } from './modules/pipedrive';

pipedrive();

// Comparison table summary

import { tableSummary } from './modules/table-summary';

tableSummary();

// Steps mobile text

import { stepsMobileText } from './modules/steps-mobile-text';

stepsMobileText();

// Accessiblity widget

import { accessibilityWidget } from './modules/accessibility-widget';

accessibilityWidget();

// CF7 Multistep

import { cf7Mutltistep } from './modules/cf7-multistep';

cf7Mutltistep();

// Supplier Ajax posts

import { supplierAjaxPosts } from './modules/supplier-ajax-posts';

supplierAjaxPosts();

// Vue Calculator

import { vueCalculator } from './modules/vue-calculator';

vueCalculator();

// Case study scroll to section

import { caseStudyScroll } from './modules/case-study-scroll';

caseStudyScroll();

// Static comparison table: sticky Feature + Skiddle columns

import { comparisonTicketingStickyColumns } from './modules/comparison-ticketing-sticky-columns';

comparisonTicketingStickyColumns();

// Sticky header hide/reveal on scroll direction

import { stickyHeader } from './modules/sticky-header';

stickyHeader();

// Hand-drawn circle highlight on scroll

import { circleHighlight } from './modules/circle-highlight';

circleHighlight();

// Stats block NumberFlow counter animation

import { statsCounter } from './modules/stats-counter';

statsCounter();

// Left-to-right marker highlight on scroll

import { markerHighlight } from './modules/marker-highlight';

markerHighlight();

// Promoter Socials on-scroll text (SplitText + ScrollTrigger)

import { promoterSocialsText } from './modules/promoter-socials-text';

promoterSocialsText();

// Promoter Socials back to top

import { psBackToTop } from './modules/promoter-socials-back-to-top';

psBackToTop();

// Promoter Socials drag cursor

import { psDragCursor } from './modules/promoter-socials-drag-cursor';

psDragCursor();

// Promoter Socials scrolling text marquee

import { psScrollingText } from './modules/promoter-socials-scrolling-text';

psScrollingText();

import { attendeesSwiper } from './swiper';

attendeesSwiper();

// Fixed section navigation bar

import { sectionNav } from './modules/section-nav';

sectionNav();

// Feature explanations

import { featureExplanations } from './modules/feature-explanations';

featureExplanations();

// Form overlay toggle

import { formOverlay } from './modules/form-overlay';

formOverlay();
